
class SettingsController {

    items: any[];
    selected: any;
    displayCountrySettings: any;

    static $inject = ['Auth', 'applicationObservable', '$state', 'OfficeUserAgency'];
    constructor(Auth, applicationObservable, public $state, private OfficeUserAgency) {

        var user = Auth.user;

        OfficeUserAgency.get({ userId: user.userId }).$promise
            .then((data) => {
                this.displayCountrySettings = data.result;

                if (user.isApplicant) {
                    this.items = [
                        {
                            name: 'Change Password',
                            state: 'app.settings.password'
                        }
                    ];
                    applicationObservable.subscribe(i => {
                        if (i.gdpr) {
                            this.items.push({
                                name: 'Communication preferences',
                                state: 'app.settings.marketing'
                            });
                        }

                        this.items.push({
                            name: 'Public profile consent',
                            state: 'app.settings.imageConsent'
                        });
                        
                        this.defineSelected();
                        
                        const unauthorizedAppStatuses = ['PLC', 'REJ', 'ACT', 'REM', 'APD', 'AWL', 'INA'];

                        if(!unauthorizedAppStatuses.includes(i.status)){
                            this.items.push({
                                name: 'Delete my data',
                                state: 'app.settings.deleteMyData'
                            });
                        }
                    });
                } else if (user.isOfficer) {
                    this.items = [
                        {
                            name: 'Application settings',
                            state: 'app.settings.application'
                        },
                        {
                            name: 'Change Password',
                            state: 'app.settings.password'
                        }
                    ];

                    if(this.displayCountrySettings){
                        this.items = [
                            ...this.items,
                            {
                                name: 'Country settings',
                                state: 'app.settings.country'
                            },
                        ]
                    }
                } else {
                    this.items = [
                        {
                            name: 'Communication preferences',
                            state: 'app.settings.marketing'
                        },
                        {
                            name: 'Change Password',
                            state: 'app.settings.password'
                        }
                    ];
                }
                this.defineSelected();
            });
    };

    defineSelected() {

        for (var item of this.items) {
            var link = item.linkStage || item.state;
            if (this.$state.includes(link)) {
                this.selected = item;
            }
        }

    }
}

angular
    .module('app')
    .controller('SettingsController', SettingsController);
